import {useEffect, useState} from "react";
import roleUtilities from "../../utilities/roleUtilities";
import { ReportSummaryCard } from "./reportSummaryCard";
import Api from "../api/api";
import Loader from "../shared/loader";
import stringHelpers from "../../utilities/stringHelpers";
import arrayUtilities from "../../utilities/arrayUtilities";
import {EmptyState} from "../dashboard/emptyState";
import Enum from "../../utilities/enum";
import { getOrdinalDayOfMonth } from "../../utilities/dateUtilities";
import { Modal } from "react-bootstrap";
import { dailyTotalsReportType, DailyTotalsScheduleModal } from "./schedule-modals/dailyTotalsScheduleModal";
import { cancellationsReportType, CancellationsScheduleModal } from "./schedule-modals/cancellationsScheduleModal";
import { averageLengthOfStayReportType, AverageLengthOfStayScheduleModal } from "./schedule-modals/averageLengthOfStayScheduleModal";
import { parkingDurationsReportType, ParkingDurationsScheduleModal } from "./schedule-modals/parkingDurationsScheduleModal";
import { breachesReportType, BreachesScheduleModal } from "./schedule-modals/breachesScheduleModal";
import { contraventionsReportType, ContraventionsScheduleModal } from "./schedule-modals/contraventionsScheduleModal";
import { pcnsIssuedReportType, PcnsIssuedScheduleModal } from "./schedule-modals/pcnsIssuedScheduleModal";
import { dataStorageReportType, DataStorageScheduleModal } from "./schedule-modals/dataStorageScheduleModal";
import { appealsReportType, AppealsScheduleModal } from "./schedule-modals/appealsScheduleModal";
import { transferOfLiabilitiesReportType, TransferOfLiabilitiesScheduleModal } from "./schedule-modals/transferOfLiabilitiesScheduleModal";
import { debtRecoveryReportType, DebtRecoveryScheduleModal } from "./schedule-modals/debtRecoveryScheduleModal";
import { pcnsPaidReportType, PcnsPaidScheduleModal } from "./schedule-modals/pcnsPaidScheduleModal";
import { voidsReportType, VoidsScheduleModal } from "./schedule-modals/voidsScheduleModal";
import { exportBreachesReportType, ExportBreachesScheduleModal } from "./schedule-modals/exportBreachesScheduleModal";
import { allowListReportType, AllowListScheduleModal } from "./schedule-modals/allowListScheduleModal";
import { sitesReportType, SitesScheduleModal } from "./schedule-modals/sitesScheduleModal";
import { vehicleAnalyticsReportType, VehicleAnalyticsScheduleModal } from "./schedule-modals/vehicleAnalyticsScheduleModal";
import { deviceStatusReportType, DeviceStatusScheduleModal } from "./schedule-modals/deviceStatusScheduleModal";
import { paymentsReportType, PaymentsScheduleModal } from "./schedule-modals/paymentsScheduleModal";
import { emailsReportType, EmailsScheduleModal } from "./schedule-modals/emailsScheduleModal";
import { lettersReportType, LettersScheduleModal } from "./schedule-modals/lettersScheduleModal";

const scheduleModalByReportType = {
    [dailyTotalsReportType]: DailyTotalsScheduleModal,
    [cancellationsReportType]: CancellationsScheduleModal,
    [averageLengthOfStayReportType]: AverageLengthOfStayScheduleModal,
    [parkingDurationsReportType]: ParkingDurationsScheduleModal,
    [breachesReportType]: BreachesScheduleModal,
    [contraventionsReportType]: ContraventionsScheduleModal,
    [pcnsIssuedReportType]: PcnsIssuedScheduleModal,
    [dataStorageReportType]: DataStorageScheduleModal,
    [appealsReportType]: AppealsScheduleModal,
    [transferOfLiabilitiesReportType]: TransferOfLiabilitiesScheduleModal,
    [debtRecoveryReportType]: DebtRecoveryScheduleModal,
    [pcnsPaidReportType]: PcnsPaidScheduleModal,
    [voidsReportType]: VoidsScheduleModal,
    [exportBreachesReportType]: ExportBreachesScheduleModal,
    [allowListReportType]: AllowListScheduleModal,
    [sitesReportType]: SitesScheduleModal,
    [vehicleAnalyticsReportType]: VehicleAnalyticsScheduleModal,
    [deviceStatusReportType]: DeviceStatusScheduleModal,
    [paymentsReportType]: PaymentsScheduleModal,
    [emailsReportType]: EmailsScheduleModal,
    [lettersReportType]: LettersScheduleModal,
}

export default function Reports({user, organisationId, clientPermittedReports, sites, clients, users, tags, token}) {
    const isClientOrClientManager = roleUtilities.isClientOrClientManager(user, organisationId)
    const isThirdPartyUser = roleUtilities.isThirdPartyManager(user, organisationId) || roleUtilities.isThirdPartyProcessor(user, organisationId)
    const isThirdPartyProcessor = roleUtilities.isThirdPartyProcessor(user, organisationId)
    const isOrganisationProcessor = roleUtilities.isOrganisationProcessor(user, organisationId)
    const isOrganisationAdmin = roleUtilities.isOrganisationAdmin(user, organisationId)
    const isOrganisationAdminOrManager = roleUtilities.isOrganisationAdminOrManager(user, organisationId)
    
    
    const [defaultTab] = useState("reports")
    const [scheduledExports, setScheduledExports] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const [deleteId, setDeleteId] = useState(null)
    const [scheduleReportType, setScheduleReportType] = useState(null)
    const [editingScheduledExport, setEditingScheduledExport] = useState(null)
    const [loadingScheduledExportId, setLoadingScheduledExportId] = useState(null)
    const [editLoadErrorMessage, setEditLoadErrorMessage] = useState(null)
    const ActiveScheduleModal = scheduleModalByReportType[scheduleReportType ?? editingScheduledExport?.reportType]
    const formatter = new Intl.DateTimeFormat(navigator.language, { weekday: 'long' });

    const renderSchedule = (item) => {
        let validityDays
        let renderedString = ""

        if (item.frequency === 0) {
            renderedString = "Daily"
        }
        else if (item.frequency === 1) {
            validityDays = Array.from({ length: 7 }, (_, i) => {
                const date = new Date(2025, 0, 6 + i);
                const formattedDay = formatter.format(date)
                if (item[formattedDay.toLowerCase()]) {
                    return stringHelpers.abbreviatedDayOfTheWeek(formattedDay)
                }
            }).filter(Boolean)
            if (!arrayUtilities.isNullOrEmpty(validityDays)) {
                renderedString += validityDays.join(" ")
            }
        } else if (item.frequency === 2) {
            renderedString = `${getOrdinalDayOfMonth(item.dayOfMonth)} of every month`
        }
        return `${ renderedString }; ${item.sendTime.slice(0, 5)}`
    }
    const getScheduledExports = () => {
        setIsLoading(true)
        setErrorMessage(null)
        Api.getScheduledExport(
            data => {
                setScheduledExports(data)
                setIsLoading(false)
            },
            error => {
                setErrorMessage(error?.errorMessage ?? "Unable to load scheduled exports")
                setIsLoading(false)
            },
            organisationId, token
        )
    }

    const closeScheduleModal = () => {
        setScheduleReportType(null)
        setEditingScheduledExport(null)
    }

    const handleScheduleSaved = () => {
        closeScheduleModal()
        getScheduledExports()
    }

    const openScheduledExportForEdit = (scheduledExportId) => {
        setEditLoadErrorMessage(null)
        setLoadingScheduledExportId(scheduledExportId)
        Api.getScheduledExportById(
            data => {
                setEditingScheduledExport(data)
                setLoadingScheduledExportId(null)
            },
            error => {
                setEditLoadErrorMessage(error?.errorMessage ?? "This scheduled export could not be loaded - it may have been deleted. The list has been refreshed.")
                setLoadingScheduledExportId(null)
                getScheduledExports()
            },
            scheduledExportId, organisationId, token
        )
    }

    useEffect(() => {
        getScheduledExports()
    }, [])

    // Mirrors the permission checks each ReportSummaryCard below uses to decide whether to render -
    // keep the two in sync, since this list drives which report types can be scheduled from this page.
    const availableReportTypes = [
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(11)) ? 11 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(12)) ? 12 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(13)) ? 13 : null,
        (isOrganisationAdmin || (isClientOrClientManager && clientPermittedReports?.includes(6))) ? 6 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(4)) ? 4 : null,
        !isThirdPartyUser && !isOrganisationProcessor && !isClientOrClientManager ? 0 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(14)) ? 14 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(15)) ? 15 : null,
        !isThirdPartyProcessor && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(2)) ? 2 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(8)) ? 8 : null,
        !isThirdPartyUser && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(9)) ? 9 : null,
        !isThirdPartyProcessor && !isOrganisationProcessor && (!isClientOrClientManager || clientPermittedReports?.includes(3)) ? 3 : null,
        isOrganisationAdmin ? 16 : null,
        (isOrganisationAdminOrManager || (isClientOrClientManager && clientPermittedReports?.includes(5))) ? 5 : null,
    ].filter(reportType => reportType !== null)

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <ul className="nav nav-tabs" id="reportslandingtabbed" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className={`nav-link ${defaultTab === 'reports' ? 'active' : ''}`} id="reports-tab" data-toggle="tab" data-target="#reports" type="button" role="tab" aria-controls="reports"
                                    aria-selected={defaultTab === 'reports'}>
                                <i className='far fa-file-alt mr-2'></i> Reports
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                onClick={getScheduledExports}
                                className={`nav-link ${defaultTab === 'scheduled-exports' ? 'active' : ''}`} id="scheduled-exports-tab" data-toggle="tab" data-target="#scheduled-exports" type="button" role="tab"
                                    aria-controls="scheduled-exports"
                                    aria-selected={defaultTab === 'scheduled-exports'}>
                                <i className='far fa-clock mr-2'></i>
                                Scheduled Reports
                            </button>
                        </li>
                    </ul>
                    <div>
                        <div className="tab-content" id="reportslandingtabbedContent">
                            <div className={`tab-pane fade p-2 bg-white ${defaultTab === 'reports' ? 'show active' : ''}`} id="reports" role="tabpanel" aria-labelledby="reports-tab">
                                <div className="reports-summaries-container-alt p-2">
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(11)) && <ReportSummaryCard
                                        key="average-stay"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Average Length of Stay",summaryDescription:"View report on the average duration of a parking session.",iconClass:"fas fa-clock",iconBackground:"dark",urlSlug:"average-stay",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(12)) && <ReportSummaryCard
                                        key="daily-totals"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Daily Totals",
                                            summaryDescription:"View report on total number of vehicles that have visited the car park daily.",
                                            iconClass:"fas fa-sort-amount-up",
                                            iconBackground:"info",
                                            urlSlug:"daily-totals",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(13)) && <ReportSummaryCard
                                        key="parking-durations"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Parking Durations",
                                            summaryDescription:"View report on total number of vehicles on the car park, broken down into durations.",
                                            iconClass:"fas fa-hourglass-half",
                                            iconBackground:"primary",
                                            urlSlug:"parking-durations",
                                        }}
                                    />}
                                    {(roleUtilities.isOrganisationAdmin(user,organisationId) || (isClientOrClientManager && clientPermittedReports?.includes(6))) && <ReportSummaryCard
                                        key="pcns-paid"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"PCN Revenue",summaryDescription:"View report on total revenue of paid PCNS.",iconClass:"fas fa-coins",iconBackground:"success",urlSlug:"pcns-paid",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(4)) && <ReportSummaryCard
                                        key="pcns-issued"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"PCNs Issued",summaryDescription:"View report on the number of PCNs issued.",iconClass:"fas fa-coins",iconBackground:"success",urlSlug:"pcns-issued",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && !isClientOrClientManager && <ReportSummaryCard
                                        key="export-breaches"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Export Breaches",summaryDescription:"Export a detailed report on breaches.",iconClass:"fas fa-exclamation-circle",iconBackground:"danger",urlSlug:"export-breaches",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(14)) && <ReportSummaryCard
                                        key="breaches"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Breaches",summaryDescription:"View report on the total number of breaches.",iconClass:"fas fa-exclamation-circle",iconBackground:"danger",urlSlug:"breaches",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(15)) && <ReportSummaryCard
                                        key="contraventions"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Contraventions",summaryDescription:"View report on the type and quantity of contraventions breached.",iconClass:"fas fa-car",iconBackground:"warning",urlSlug:"contraventions",
                                        }}
                                    />}
                                    {!roleUtilities.isThirdPartyProcessor(user,organisationId) && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(2)) &&
                                        <ReportSummaryCard
                                            key="appeals"
                                            organisationId={organisationId}
                                            reportSummary={{
                                                title:"Appeals",summaryDescription:"View report on the type and quantity of appeals.",iconClass:"fas fa-question-circle",iconBackground:"warning",urlSlug:"appeals",
                                            }}
                                        />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(8)) && <ReportSummaryCard
                                        key="cancellations"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Cancellations",summaryDescription:"View report on the type and quantity of cancellations.",iconClass:"fas fa-times-circle",iconBackground:"danger",urlSlug:"cancellations",
                                        }}
                                    />}
                                    {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(9)) && <ReportSummaryCard
                                        key="voids"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Voids",summaryDescription:"View report on the type and quantity of voids.",iconClass:"fas fa-times-circle",iconBackground:"danger",urlSlug:"voids",
                                        }}
                                    />}
                                    {!roleUtilities.isThirdPartyProcessor(user,organisationId) && !roleUtilities.isOrganisationProcessor(user,organisationId) && (!isClientOrClientManager || clientPermittedReports?.includes(3)) &&
                                        <ReportSummaryCard
                                            key="transfer-of-liabilities"
                                            organisationId={organisationId}
                                            reportSummary={{
                                                title:"Transfer of Liabilities",
                                                summaryDescription:"View report on the type and quantity of Transfer of Liabilities.",
                                                iconClass:"fas fa-exchange-alt",
                                                iconBackground:"default",
                                                urlSlug:"transfer-of-liabilities",
                                            }}
                                        />}
                                    {roleUtilities.isOrganisationAdmin(user,organisationId) && <ReportSummaryCard
                                        key="data-storage"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Data Storage",summaryDescription:"View report on the type and quantity of Data Storage.",iconClass:"far fa-save",iconBackground:"warning",urlSlug:"data-storage",
                                        }}
                                    />}

                                    {(roleUtilities.isOrganisationAdminOrManager(user,organisationId) || (isClientOrClientManager && clientPermittedReports?.includes(5))) && <ReportSummaryCard
                                        key="debt-recovery"
                                        organisationId={organisationId}
                                        reportSummary={{
                                            title:"Debt Recovery",summaryDescription:"View report on the type and quantity of Debt Recovery.",iconClass:"fas fa-money-bill-wave",iconBackground:"success",urlSlug:"debt-recovery",
                                        }}
                                    />}
                                </div>
                            </div>
                            <div className={`tab-pane fade bg-white ${defaultTab === 'scheduled-exports' ? 'show active' : ''}`} id="scheduled-exports" role="tabpanel" aria-labelledby="scheduled-exports-tab">
                                <div className="d-flex justify-content-end align-items-center">
                                    <button
                                        disabled={ arrayUtilities.isNullOrEmpty(availableReportTypes) }
                                        id="create-scheduled-report-dropdown"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        className="btn btn-success btn-sm mr-2 mt-2">Create Scheduled Report<i className="fas fa-chevron-down ml-2"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-left dropdown-menu-card dropdown-caret-none" aria-labelledby="create-scheduled-report-dropdown" style={ { width: "300px" } }>
                                        <div className="d-flex flex-column pb-3">
                                            {
                                                availableReportTypes.map(
                                                    reportType => <button
                                                        key={ reportType }
                                                        type="button"
                                                        className="my-1 dropdown-item font-weight-semi-bold d-flex justify-content-between align-items-center"
                                                        onClick={ () => setScheduleReportType(reportType) }
                                                    >{ Enum.ReportType[reportType] } <i className="fas fa-chevron-right"></i></button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    isLoading
                                        ? <Loader />
                                        : !stringHelpers.isNullOrEmpty(errorMessage)
                                            ? <div className="w-100 h-100 d-flex justify-content-between align-items-center px-4">{errorMessage}</div>
                                            : !arrayUtilities.isNullOrEmpty(scheduledExports)
                                                ? <div className="bg-white py-2 scheduled-reports-list">
                                                    {!stringHelpers.isNullOrEmpty(editLoadErrorMessage) && <p className="text-danger fs--1 px-3 mb-2">{editLoadErrorMessage}</p>}
                                                    <table className="table table-sm mb-0 px-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                        <thead className="bg-200 text-900">
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Report</th>
                                                            <th>Schedule</th>
                                                            <th>Active</th>
                                                            <th>&nbsp;</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                scheduledExports.map((scheduledExport) => {
                                                                    const isOpeningForEdit = loadingScheduledExportId === scheduledExport.id
                                                                    return (
                                                                        <tr className={scheduledExport.isDeleted ? "text-muted" : ""} key={scheduledExport.id}>
                                                                            <td>
                                                                                <button type="button" disabled={isOpeningForEdit} className="btn btn-none m-0 p-0" onClick={() => openScheduledExportForEdit(scheduledExport.id)}>
                                                                                    <h6 className="mb-0">{scheduledExport.name}</h6>
                                                                                </button>
                                                                            </td>
                                                                            <td>{Enum.ReportType[scheduledExport.reportType]}</td>
                                                                            <td>{renderSchedule(scheduledExport)}</td>
                                                                            <td>
                                                                                {scheduledExport.isActive && <i className="fa fa-check text-success"></i>}
                                                                                {!scheduledExport.isActive && <i className="fa fa-times text-danger"></i>}
                                                                            </td>
                                                                            <td className="text-right">
                                                                                <button onClick={() => openScheduledExportForEdit(scheduledExport.id)} disabled={isOpeningForEdit} type="button" className="btn btn-none m-0 p-0">
                                                                                    <span className="d-inline-block text-center mr-2 edit-icon-slot">
                                                                                        {isOpeningForEdit && <span className="spinner-border" role="status" aria-label="Loading scheduled export"></span>}
                                                                                        {!isOpeningForEdit && <i className="far fa-edit"></i>}
                                                                                    </span>
                                                                                </button>
                                                                                <button onClick={() => setDeleteId(scheduledExport.id)} type="button" className="btn btn-none m-0 p-0">
                                                                                    <i className="fa fa-trash-alt"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div> : <div className="bg-white py-2">
                                                    <EmptyState message="No Data available"/>
                                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                !stringHelpers.isNullOrEmpty(deleteId) &&
                <Modal show>
                    <Modal.Header className="d-flex align-items-center justify-content-between">
                        <Modal.Title>Delete scheduled export</Modal.Title>
                        <button type="button" className="btn btn-none p-0 m-0" onClick={() => setDeleteId(null)}>
                            <i className="fa fa-times"></i>
                        </button>
                    </Modal.Header>

                    <Modal.Body>Are you sure?</Modal.Body>

                    <Modal.Footer>
                        <button onClick={() => setDeleteId(null)} className="btn btn-secondary">Cancel</button>
                        <button onClick={() => {
                            setIsLoading(true)
                            Api.deleteScheduledExport(
                                data => {
                                    if (data.isError) {
                                        setErrorMessage(data.errorMessage)
                                        setIsLoading(false)
                                    } else {
                                        getScheduledExports()
                                    }
                                    setDeleteId(null)
                                },
                                error => {
                                    setErrorMessage(error?.errorMessage ?? "Unable to delete scheduled export")
                                    setDeleteId(null)
                                    setIsLoading(false)
                                },
                                deleteId, 
                                organisationId, token
                            )
                        }} className="btn btn-danger">Delete</button>
                    </Modal.Footer>
                </Modal>
            }
            {
                ActiveScheduleModal && sites && clients &&
                <ActiveScheduleModal
                    sites={sites}
                    clients={clients}
                    users={users}
                    tags={tags || []}
                    organisationId={organisationId}
                    token={token}
                    scheduledExport={editingScheduledExport}
                    onCancel={closeScheduleModal}
                    onSaved={handleScheduleSaved}
                />
            }
        </div>)
}